import axios from "axios";
import { SERVER_URL } from "../constants/server";

export const submitDailyCallsExam = (data, token) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/",
    { ...data, token },
    { withCredentials: true },
  );

export const getAllDailyCallsExams = (token, limit = 50, offset = 0) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/all",
    { token, limit, offset },
    { withCredentials: true },
  );

export const deleteDailyCallsExam = (id, token) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/delete",
    { id, token },
    { withCredentials: true },
  );

export const markDailyCallsExamNoShow = (id, token) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/no-show",
    { id, token },
    { withCredentials: true },
  );

export const cancelDailyCallsExam = (id, token) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/cancel",
    { id, token },
    { withCredentials: true },
  );

// date is YYYY-MM-DD and times are HH:MM, as produced by the date and time inputs
export const rescheduleDailyCallsExam = (id, examDate, startTime, endTime, token) =>
  axios.post(
    SERVER_URL + "/api/daily-calls-exams/reschedule",
    {
      id,
      token,
      exam_date: examDate,
      exam_start_time: startTime,
      exam_end_time: endTime,
    },
    { withCredentials: true },
  );
